<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24">
    <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2">
      <path
        stroke-dasharray="60"
        stroke-dashoffset="60"
        stroke-opacity=".3"
        d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3Z"
      >
        <animate fill="freeze" attributeName="stroke-dashoffset" dur="1.3s" values="60;0" />
      </path>
      <path stroke-dasharray="15" stroke-dashoffset="15" d="M12 3C16.9706 3 21 7.02944 21 12">
        <animate fill="freeze" attributeName="stroke-dashoffset" dur="0.3s" values="15;0" />
        <animateTransform
          attributeName="transform"
          dur="1.5s"
          repeatCount="indefinite"
          type="rotate"
          values="0 12 12;360 12 12"
        />
      </path>
    </g>
  </svg>
</template>

<style module>
.lsi {
  composes: global(_relative);
  composes: global(_h24);
  composes: global(_inline);

  animation: ldx-cycle 1s infinite linear;
  transform-origin: 50% 50%;
  transform-box: fill-box;
  color: inherit;
  box-sizing: content-box;
  width: 24px;
}

.lsi::after {
  border-radius: 50%;
  border: 3px solid #292929;
  border-left-color: #f1f1f1;
  content: '';
  display: block;
  width: 24px;
  height: 24px;
  box-sizing: border-box;
  transform-origin: 0 0;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

@keyframes ldx-cycle {
  0% {
    animation-timing-function: cubic-bezier(0.3333, 0.3333, 0.6667, 0.6667);
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
